export default __webpack_public_path__ + "static/media/person_1.ee153877.jpg";